import Vue from 'vue';
import VeeValidate from 'vee-validate';
import BootstrapVue from 'bootstrap-vue';
import validationMessagesES from './validationMessagesES.js';
import Axios from 'axios';
// Axios.defaults.baseURL = 'http://localhost:3000/';
// API_URL viene de la confguracion de entorno en /config
Axios.defaults.baseURL = process.env.API_URL;
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Axios.defaults.headers.common['x-app-id'] = process.env.APP_ID;

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
	dictionary: {
		es: {
      messages: validationMessagesES
    }
	},
	locale: 'es',
	delay: 100
});

Vue.use(BootstrapVue);

Vue.component('top-bar', require('../components/TopBar'));
Vue.component('spinner', require('../components/Spinner'));



// WEBPACK FOOTER //
// ./src/other/vueConfig.js